import RevvGrid from "./RevvGrid";

export default RevvGrid;



// WEBPACK FOOTER //
// ./src/commonComponents/RevvGrid/index.js